import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { SnackbarContent } from "notistack";
import { forwardRef } from "react";
import * as IconComponents from "../icons";
import { Typography } from "../Typography";
import { Button } from "../Button";
const defaultIconName = (variant) => {
    switch (variant) {
        case "error":
            return "Error";
        case "warning":
            return "Warning";
        case "success":
            return "SuccessCircle";
        case "info":
        default:
            return "Info";
    }
};
export const ToastContent = forwardRef((props, forwardedRef) => {
    const { message, variant, action, id, subtext, otherIconName, callToActionFunction, callToActionText, callToActionTrigger = "button", } = props;
    const iconName = variant === "other" && !!otherIconName
        ? otherIconName
        : defaultIconName(variant);
    const Icon = IconComponents[`${iconName}Icon`];
    return (_jsxs(SnackbarContent, { ref: forwardedRef, className: classNames([
            "rounded",
            variant === "error" && [
                "bg-background-critical",
                "dark:bg-background-critical-darkmode",
                "text-text-primary",
                "dark:text-text-primary-darkmode",
            ],
            variant !== "error" && [
                "bg-background-tertiary-darkmode",
                "text-text-primary-inverse",
            ],
            "!flex-nowrap",
            "w-48",
            "drop-shadow",
            "dark:drop-shadow-dark",
            "p-2",
        ]), role: "alert", style: { overflowWrap: "anywhere" }, children: [_jsx("div", { className: "flex items-start pt-0.5 mr-1", children: _jsx(Icon, {}) }), _jsxs("div", { children: [_jsx(Typography, { variant: "body-medium-emphasis", children: message }), subtext && _jsx(Typography, { children: subtext }), callToActionFunction && callToActionText && (_jsx("div", { className: "mt-1", children: callToActionTrigger === "button" ? (_jsx(Button, { variant: "secondary-neutral", text: callToActionText, onClick: callToActionFunction, isForcedDarkMode: variant !== "error" })) : (_jsx("button", { onClick: callToActionFunction, children: _jsx(Typography, { variant: "body-medium-emphasis", color: variant === "error"
                                    ? "text-primary"
                                    : "text-primary-inverse", className: "underline", children: callToActionText }) })) }))] }), _jsx("div", { className: "ml-auto", children: action(id, variant) })] }));
});
//# sourceMappingURL=ToastContent.js.map